import { CrunchServiceWithContext } from "@crunchdao/sdk";
import { EnhancedBaseCommand } from "@crunchdao/shared-cli";

export class EndCommand extends EnhancedBaseCommand {
  private getCrunchService() {
    return CrunchServiceWithContext({
      program: this.program,
    });
  }

  async execute(crunchName: string): Promise<void> {
    try {
      const crunchService = this.getCrunchService();

      await this.executeOrProposeInstructions(async () => {
        return await crunchService.endCrunchInstructions(crunchName, this.getSigner());
      }, `End crunch "${crunchName}" (includes payout margin distribution)`);

      if (!this.isMultisigMode()) {
        this.success("Crunch ended successfully", {
          crunchName,
        });
      }
    } catch (error) {
      this.handleEndError(error, crunchName);
    }
  }

  private handleEndError(error: any, crunchName: string): never {
    // Check for invalid crunch state to end error
    const isInvalidCrunchStateToEnd = error?.error?.errorCode?.code === "InvalidCrunchStateToEnd";

    if (isInvalidCrunchStateToEnd) {
      const customError = this.createEnhancedError(
        `Cannot end crunch "${crunchName}". The crunch is not in the started state (it may already be ended, not started yet, or in another state).`,
        "InvalidCrunchStateToEndError",
        "INVALID_CRUNCH_STATE_TO_END",
        {
          crunchName,
          errorCode: error.error?.errorCode?.code || "InvalidCrunchStateToEnd",
          errorNumber: error.error?.errorCode?.number,
        },
        error
      );

      return this.handleError(customError);
    }

    // Fall back to generic transaction error handling
    return this.handleTransactionError(error, crunchName);
  }
}
